export default {
  init() {
    // JavaScript to be fired on the about us page

    const tripId = $("#trip_id").data("id");
    const enquiryType = $("#enq_type").data("type");

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "post",
      data: {
        action: "get_trips",
      },
      success: function (response) {
        console.log(JSON.parse(response)); //eslint-disable-line
        renderOptions(JSON.parse(response));
      },
      error: function (err) {
        console.log(err); //eslint-disable-line
      },
    });

    function renderOptions(data) {
      let select = $("#trip-select");
      let textTrip = $("#contact-comments");
      if (select.length) {
        select.empty();
        Object.keys(data).map((i) => {
          let title = $("<textarea />").html(data[i].title).text();
          let optionId = data[i].id;
          if (enquiryType === "private" && optionId === tripId)
            $('textarea[name="message"]').text(
              `I am interested in booking a private trip for ${title}`
            );
          if (enquiryType === "custom" && optionId === tripId)
            $('textarea[name="message"]').text(
              `I am interested in customising the ${title}`
            );
          $("<option />", {
            text: title,
            value: title,
          })
            .attr("data-id", optionId)
            .appendTo(select);

          if (optionId === tripId) {
            select.val(title);
          }
        });
      } else if (textTrip.length) {
        Object.keys(data).map((i) => {
          let optionId = data[i].id;
          if (optionId === tripId) {
            textTrip.text(
              `I am interested in booking a private trip for: ${data[i].title}`
            );
          }
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/enquiryForm.js